export const GET_CRITERIA_TAB = 'GET_CRITERIA_TAB';
export const UPDATE_FILE = 'UPDATE_FILE';
export const GET_RECORDS_TAB = 'GET_RECORDS_TAB'
export const GET_HOLDING_TAB ='GET_HOLDING_TAB'
export const GET_IMPORT_TAB = 'GET_IMPORT_TAB'